import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareAccessRedirectRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareAccessRedirectRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyPeopleSettings, peopleAccessRedirect } from './ui/project-settings/people/index.tsx';
import {
	getSettingsNavigationResources,
	SOFTWARE_PRODUCT,
} from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsSoftwareAccessRedirectRouteEntry: Route = createEntry(
	projectSettingsSoftwareAccessRedirectRoute,

	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: peopleAccessRedirect(`/jira/${SOFTWARE_PRODUCT}`),
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyPeopleSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
